var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileIncomplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1161.1 1161.1"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 580.6,
    cy: 580.6,
    r: 565.6,
    fill: "#10395C",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 580.6,
    cy: 777.8,
    r: 32.6,
    transform: "rotate(-22.5 580.529 777.745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.6 306.6c-81.3 0-147.4 66.1-147.4 147.4 0 18.2 14.8 33.1 33.1 33.1s33.1-14.8 33.1-33.1c0-44.8 36.4-81.2 81.2-81.2s81.2 36.4 81.2 81.2-36.4 81.2-81.2 81.2c-18.2 0-33.1 14.8-33.1 33.1v95.2c0 18.2 14.8 33.1 33.1 33.1s33.1-14.8 33.1-33.1v-65.9l3.7-1c31-8 59.1-26.4 79.1-51.8 10-12.7 17.8-26.8 23.1-42 5.5-15.7 8.3-32.1 8.3-48.9 0-81.2-66.1-147.3-147.3-147.3z"
  }))));
}

export default SvgProfileIncomplete;